export default __webpack_public_path__ + "static/media/fwfs.01b8e053.png";